<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('teams.create_team') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.team') }} <strong>{{ team.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-team-new *ngIf="newMode()"></app-team-new>
            <app-team-basedata *ngIf="editMode()" [team]="team"></app-team-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
